import { useEffect, useRef, useState } from "react";
import "../../lib/form/form.scss";
import "./Signup.scss";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import axios from "axios";
import { set, useForm } from "react-hook-form";
import ConfirmModal from "../../components/ConfirmModal";
import Post from "../../utils/postUtil";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Signup() {
  let navigate = useNavigate();

  // 회원 정보
  const [checkPrivacy, setCheckPrivacy] = useState(false); //개인정보동의 체크 플래그
  const [postNum, setPostNum] = useState(""); //우편번호
  const [address, setAddress] = useState(""); //주소
  const [personallInfo, setPersonallInfo] = useState([]); // 개인정보동의

  // 개인정보 동의 체크
  let [check, setCheck] = useState(false);

  // 회원가입 개인정보 처리방침
  const getPersonalInfoData = async () => {
    try {
      const response = await axios.get("/api/contents", {
        params: {
          type: 5,
        },
      });
      setPersonallInfo(response.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  // 모달
  const [showModal, setShowModal] = useState(false);
  const [idModal, setIdModal] = useState(false);
  const [idFalseModal, setIdFalseModal] = useState(false);
  const [comNumModal, setComNumModal] = useState(false);
  const [comNumFalseModal, setComNumFalseModal] = useState(false);
  const [personalOKModal, setPersonalOKModal] = useState(false);

  // 우편번호
  const [enroll_company, setEnroll_company] = useState({
    zonecode: "",
    address: "",
  });

  // react hook form
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const onError = (error) => {
    console.log(error);
  };
  const userPwd = useRef({});
  userPwd.current = watch("userPw", "");
  let userId = useRef({});
  userId = watch("userId", "");

  // Submit 제출
  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`/api/committee-member`, {
        id: data.userId,
        password: data.userPw,
        checkpassword: data.userPwConfirm,
        organization: data.userOrganization,
        email: data.userEmail,
        name: data.userName,
        position: data.userPosition,
        postNum: enroll_company.zonecode,
        address1: enroll_company.address,
        address2: data.userDetailAddress,
        telNum: data.userTelNum.replace(/-/gi, ""),
      });
      Swal.fire({
        icon: "success",
        title: "완료",
        text: "회원가입 신청이 완료되었습니다",
        confirmButtonColor: "dodgerBlue",
        iconColor: "dodgerBlue",
      });
      navigate("/");
    } catch (error) {
      console.log(error);
      if (error.response.status === 409) {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "중복체크 또는 입력란을 확인해 주세요.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "관리자에게 문의하십시오.",
        });
      }
    }
  };

  // 우편번호 입력
  const handleInput = (e) => {
    setEnroll_company({
      ...enroll_company,
      [e.target.name]: e.target.value,
    });
    setPostNum(enroll_company.zonecode);
    setAddress(enroll_company.address);
  };

  // 아이디 중복체크 모달
  const onCheckDupId = async (e) => {
    const response = await axios.get("/api/committee-member-dupl", {
      params: { id: userId },
    });

    if (response.data === 0) {
      // 중복되지 않은 아이디
      e.preventDefault();
      setIdModal(true);
    } else {
      // 중복된 아이디
      setIdFalseModal(true);
      e.preventDefault();
    }
  };
  // 개인정보 수집 동의 모달
  const personalOK = async (e) => {
    if (!checkPrivacy) {
      setPersonalOKModal(true);
      e.preventDefault();
    }
  };

  const handleComplete = () => {
    setShowModal(!showModal);
  };
  const closeDoneModal = () => {
    setIdModal(false);
    setIdFalseModal(false);
    setPersonalOKModal(false);
  };

  useEffect(() => {
    getPersonalInfoData();
  }, []);

  return (
    <>
      {showModal ? (
        <div className="popup_bg_bbs" onClick={handleComplete}>
          <div className="popup_bbs">
            {/* <span className='close_btn' onClick={closeModal}><MdClose /></span> */}
            {
              <Post
                company={enroll_company}
                setcompany={setEnroll_company}
                showmodal={setShowModal}
                setPostNum={setPostNum}
                setAddress1={setAddress}
              ></Post>
            }
          </div>
        </div>
      ) : null}
      {idModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"사용 가능"}
          content={`${userId} 중복되지 않은 아이디입니다.`}
        />
      ) : null}
      {idFalseModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"사용 불가능"}
          content={`${userId} 중복된 아이디 입니다.`}
        />
      ) : null}
      {personalOKModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"개인정보 약관 동의"}
          content={`개인정보 약관에 동의 하십시오.`}
        />
      ) : null}
      <div className="contain joinus_contain joinus_committee">
        <h1 style={{ height: "2rem" }}></h1>
        <form
          className="form_contain"
          onSubmit={handleSubmit(onSubmit, personalOK)}
        >
          <div className="form_wrap ">
            <h2>개인정보 수집·이용·제공 동의서</h2>
            <div className="textarea_wrap consent">
              <div
                className="jodit-wysiwyg"
                dangerouslySetInnerHTML={{ __html: personallInfo.contents }}
              ></div>
            </div>
            <div className="input_wrap agree_btn ">
              <input
                type="checkbox"
                id="_check0"
                name="personalInfo"
                {...register("personalInfo", {
                  required: "* 개인정보 약관에 동의 하십시오.",
                })}
                onClick={(e) => {
                  e.target.checked
                    ? setCheckPrivacy(true)
                    : setCheckPrivacy(false);
                }}
              />
              <label
                htmlFor="_check0"
                className="checkbox_wrap"
                style={{ width: "10000%" }} /* onClick={()=>toggleMenu()} */
              >
                <div className="check_icon">
                  {/* {check ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />} */}
                </div>
                내용을 모두 확인하였으며, 동의합니다.
              </label>
            </div>
            <div className="error_msg">
              {errors.personalInfo && <p>{errors.personalInfo?.message}</p>}
            </div>
          </div>
          <div className="form_wrap">
            <h2 className="alert_qoute">*표시는 필수값입니다.</h2>

            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="아이디*"
                name="companyid"
                onChange={userId}
                {...register("userId", {
                  required: "* 아이디는 필수 입력입니다.",
                  pattern: {
                    value: /^[a-z]+[a-z0-9]{5,19}$/g,
                    message:
                      "* 아이디는 영문,숫자 조합의 6자리 이상 20자리 이하입니다.",
                  },
                  //   value: /^[A-Za-z+]{4,20}$/,
                  //   message: "* 아이디는 영문 4자리 이상 20자리 이하입니다.",
                  // },
                })}
              />
              {userId.length === 0 || errors.userId ? (
                <button
                  className="btn_none"
                  type="button"
                  onClick={onCheckDupId}
                  disabled
                >
                  중복체크
                </button>
              ) : (
                <button
                  className="btn_color"
                  type="button"
                  onClick={onCheckDupId}
                >
                  중복체크
                </button>
              )}
            </div>
            <div className="error_msg">
              {errors.userId && <p>{errors.userId?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                name="userPw"
                className="input_box"
                type="password"
                placeholder="비밀번호*"
                onChange={onError}
                {...register("userPw", {
                  required: "* 비밀번호는 필수 입력입니다.",
                  pattern: {
                    value:
                      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,16}$/,
                    message:
                      "* 비밀번호는 숫자와 영문대,소문자,특수문자 조합의 8자리 이상 16자리이하 구성입니다.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userPw && <p>{errors.userPw?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="password"
                placeholder="비밀번호 확인*"
                onChange={onError}
                {...register("userPwConfirm", {
                  required: "* 비밀번호 확인은 필수 입력입니다.",
                  validate: (value) =>
                    value === userPwd.current ||
                    "* 비밀번호가 일치하지 않습니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userPwConfirm && <p>{errors.userPwConfirm?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="실무자 이름*"
                onChange={onError}
                {...register("userName", {
                  required: "* 실무자 이름은 필수 입력입니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userName && <p>{errors.userName?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="소속/회사"
                {...register("userOrganization", {})}
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="직책*"
                {...register("userPosition", {
                  required: "* 직책은 필수 입력입니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userPosition && <p>{errors.userPosition?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="이메일*"
                onChange={onError}
                {...register("userEmail", {
                  required: "* 이메일은 필수 입력입니다.",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "*이메일 형식을 확인하세요.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userEmail && <p>{errors.userEmail?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="실무자 연락처* (숫자)"
                onChange={onError}
                {...register("userTelNum", {
                  required: "* 실무자 연락처는 필수 입력입니다.",
                  pattern: {
                    value:
                      // /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})[0-9]{3,4}[0-9]{4}$/,
                      /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/,
                    message: "* 연락처 형식을 확인하세요.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userTelNum && <p>{errors.userTelNum?.message}</p>}
            </div>

            <div className="input_wrap">
              <input
                style={{ backgroundColor: "#e8f0fe" }}
                className="input_box"
                type="text"
                placeholder="우편번호"
                onChange={handleInput}
                onClick={(e) => {
                  e.preventDefault();
                  handleComplete();
                }}
                name="postNum"
                defaultValue={enroll_company.zonecode}
                {...register("userPostNum", {})}
                readOnly
              />
              <button
                className="btn_color"
                type="button"
                onClick={handleComplete}
                defaultValue={enroll_company.address}
              >
                주소검색
              </button>
            </div>
            <div className="input_wrap">
              <input
                style={{ backgroundColor: "#e8f0fe" }}
                className="input_box"
                type="text"
                placeholder="주소"
                defaultValue={enroll_company.address}
                onClick={(e) => {
                  e.preventDefault();
                  handleComplete();
                }}
                readOnly
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="상세주소"
                {...register("userDetailAddress", {})}
              />
            </div>

            <div className="input_wrap btn_wrap">
              <button className="btn_color requir_btn">회원가입 요청</button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
export default Signup;
